import { patch } from 'bootstrap/load-snabbdom';
import { VNode } from 'snabbdom/vnode';
import toVNode from 'snabbdom/tovnode';
import { NewsItem } from 'lib/sdx/gcr-pressrelease/GcrPressReleaseNewsItem';

function CardItem(
	{
		title,
		category,
		date,
		dateAndTime,
		image,
		imageUrl,
		url,
		lead,
		heading,
		moreLabel,
		cardsLayout,
	} : {
		title : string;
		category : string;
		date : string;
		dateAndTime : string;
		image : Record<string, string>;
		imageUrl : string;
		url : string;
		lead : string;
		heading : string;
		moreLabel : string;
		cardsLayout : boolean;
	}) {


	if (cardsLayout) {
		return <div className={'col-xs-12 col-md-4 margin-bottom-2'}>
			<a href={url} role="none"
				className={'card card--image-top card--clickable card--border padding-bottom-2 ' + ((image && image.url) || imageUrl ? 'card--no-color' : 'card--dark')}>
				{(image && image.url) || imageUrl  ? <div className="card__image" style={{backgroundImage : `url(${imageUrl || image.url})`}}></div> : ''}
				<div className="card__body">
					<div className="card__header">
						<div className="row">
							<div className="col-xs-6 sc-navy">{category && (<span className="small-text">{category}</span>)}</div>
							<div className="col-xs-6 text-align-right sc-gray">{date && (<span className="small-text">{date}</span>)}</div>
						</div>
						{title && (<h4 className="sc-navy font--semi-bold">{title}</h4>)}

					</div>
				</div>
				<div className="card__footer padding-2">
					<span className="int-blue">{moreLabel}</span>
				</div>
			</a>
		</div>;
	}

	return <div className={'news-item clearfix ' + ((image && image.url) || imageUrl ? 'news-with-image' : '')}>
		<h4>
			{heading}
		</h4>
		<a href={url} className="clearfix" role="none">
			{image && image.url ? <img src={image.url} alt={image.altText } width={image.width} height={image.height}/> : ''}
			{imageUrl && <img src={imageUrl} alt="teaser image" width="360" height="184"/>}
			<div className="news-text margin-top-0">
				<div className="metadata">
					<span className="tags text-sm font font--semi-bold">
						{category}
					</span>
					<span className="date text-sm sc-gray-light">
						{dateAndTime}
					</span>
				</div>
				{title && (<h4 className="sc-navy font--semi-bold margin-bottom-0">{title}</h4>)}
				{lead && (<p className="news-text-lead text-b1">{lead}</p>)}
			</div>
		</a>
	</div>;

}

export class ResultCard {
	private container : VNode;
	private readonly more : string;

	constructor(element : HTMLElement, more : string) {
		this.container = toVNode(element);
		this.more = more;
	}

	public renderItems(
		items : NewsItem[],
		cardsLayout : boolean,
	) {

		this.container = patch(
			this.container,
			<div className="news-results row">
				{items.map(
					c => <CardItem
						title={c.title}
						category={c.categories.join(', ')}
						date={c.date}
						dateAndTime={c.dateAndTime || ''}
						image={c.imageMobile}
						imageUrl={c.imageUrl || ''}
						url={c.url}
						lead={c.lead}
						heading={c.heading || ''}
						moreLabel={this.more}
						cardsLayout={cardsLayout}/>,
				)}
			</div>,
		);
	}

	public clear() : void {
		this.container = patch(this.container, <div className="news-results"></div>);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/sdx/gcr-pressrelease/ResultCard.tsx